/**
 * Import depedencies
 */

import { combineReducers } from 'redux';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

/**
 * Import reducers
 */

import { connectRouter } from 'connected-react-router';
import { reducer as notificationsReducer } from 'reapop';

import authenticationReducer from './authentication';
import taskReducer from './task';
import agendaReducer from './agenda';
import subjectReducer from './subject';
import colorReducer from './color';
import usersubjectReducer from './usersubject';
import newUsersubjectReducer from './new-usersubject';
import newHomeworkReducer from './new-homework';
import newTimeslotReducer from './new-timeslot';
import homeworkReducer from './homework';
import organisationReducer from './organisation';
import holidayReducer from './holiday';
import eventReducer from './event';
import conflictReducer from './conflict';

/**
 * List all reducers
 */

const authenticationPersistConfig = {
    key: 'authentication',
    storage: localForage,
    whitelist: [ 'user', 'token' ]
};

const taskPersistConfig = {
    key: 'task',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const agendaPersistConfig = {
    key: 'agenda',
    storage: localForage,
    whitelist: [ 'hour', 'teacher', 'room' ]
};

const subjectPersistConfig = {
    key:'subject',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const colorPersistConfig = {
    key:'color',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const userSubjectPersistConfig = {
    key:'user_subject',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const newUserSubjectPersistConfig = {
    key:'new_usersubject',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const newHomeworkPersistConfig = {
    key:'new_homework',
    storage: localForage,
    whitelist: []
};
const newTimeslotPersistConfig = {
    key:'new_timeslot',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const homeworkPersistConfig = {
    key:'homework',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const holidayPersistConfig = {
    key:'holiday',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const organisationPersistConfig = {
    key:'organisation',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const eventPersistConfig = {
    key:'event',
    storage: localForage,
    whitelist: [ 'entities' ]
};

const conflictPersistConfig = {
    key:'conflict',
    storage: localForage,
    whitelist: [ 'entities' ]
};

export default (history) => combineReducers({
    router: connectRouter(history),
    notifications: notificationsReducer(),
    authentication: persistReducer(authenticationPersistConfig, authenticationReducer),
    task: persistReducer(taskPersistConfig, taskReducer),
    agenda: persistReducer(agendaPersistConfig, agendaReducer),
    subject: persistReducer(subjectPersistConfig, subjectReducer),
    color: persistReducer(colorPersistConfig, colorReducer),
    user_subject: persistReducer(userSubjectPersistConfig, usersubjectReducer),
    new_usersubject: persistReducer(newUserSubjectPersistConfig, newUsersubjectReducer),
    new_homework: persistReducer(newHomeworkPersistConfig, newHomeworkReducer),
    new_timeslot: persistReducer(newTimeslotPersistConfig, newTimeslotReducer),
    homework: persistReducer(homeworkPersistConfig, homeworkReducer),
    organisation: persistReducer(organisationPersistConfig, organisationReducer),
    holiday: persistReducer(holidayPersistConfig, holidayReducer),
    event: persistReducer(eventPersistConfig, eventReducer),
    conflict: persistReducer(conflictPersistConfig, conflictReducer)
});
